import styled from 'styled-components';
import { backgroundImage, themeGet, flex } from 'styled-system';

import { Box, BgImage } from 'src/kit';

export const CardBasis = styled(Box).attrs({ as: 'a' })`
  height: 340px;
  flex: 1 1 calc(33% - 28px);
  text-decoration: none;
  margin-top: 28px;
  border-radius: 4px;
  position: relative;
  border: 1px solid ${themeGet('colors.iceBlueTwo')};
  transition: box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    box-shadow: ${themeGet('shadows.card')};
  }

  @media screen and (max-width: ${themeGet('breakpoints.lg')}px) {
    flex: 1 1 100% !important;
  }
`;

const MediaCard = styled(CardBasis)<{ href: string; src: string; flex: string }>`
  ${backgroundImage}
  ${flex}

  box-shadow: ${themeGet('shadows.shadow2')};
  background-color: ${themeGet('colors.darkGreyBlueTwo')};
  background-image: linear-gradient(
    to bottom, transparent, ${themeGet('colors.darkGreyBlueTwo')}
  ), url("${({ src }) => src}");
  background-repeat: no-repeat;
  background-size: cover;

  .wrapper {
    position: absolute;
    bottom: 20px;
    left: 20px;

    .logo {
      width: 70px;
      height: 70px;
      border-radius: 50%;
    }
  }
`;

const VideoCard = styled(MediaCard).attrs({ as: 'iframe' })``;

const CompanyBaseCard = styled(CardBasis)`
  flex-direction: column;
  .card-content {
    padding: 20px 20px 30px 20px;
  }

  .name {
    overflow: visible;
  }
`;
const CompanyBaseCover = styled(BgImage)`
  height: 110px;
  width: 100%;
  position: relative;
  .logo {
    position: absolute;
    bottom: 20px;
    left: 20px;
    width: 70px;
    height: 70px;
    border-radius: 50%;
  }
  ${backgroundImage}
`;

const InfluincerCard = styled(CardBasis)`
  padding: 20px 20px 30px 20px;
`;

const ActivitiesCard = styled(CardBasis)`
  flex: 1 1 calc(66% - 28px);
  padding: 20px 20px 30px 20px;
  .tab-content-wrapper {
    overflow: auto;
    height: 190px;
  }

  [data-reach-tabs] {
    margin-top: 4px;
  }

  [data-reach-tab-list] {
    display: block;
    border-bottom: 1px solid #eaeef1;
    overflow: auto;
    background: transparent;

    & > button {
      padding-bottom: 6px;
    }
  }

  [data-reach-tab-panels] {
    max-height: 190px;
    margin-top: 18px;
  }

  [data-reach-tab] {
    margin-right: 5px;
    margin-top: 10px;
    padding: 0 4px 8px;
    border-bottom: 4px solid transparent;

    &:active {
      background: none;
      outline: 0;
    }
  }

  [data-reach-tab][data-selected] {
    border-bottom: 4px solid #64b5f7;
  }

  p {
    color: ${themeGet('colors.textSecondary')};
    font-size: 14px;
    line-height: 1.57;
  }
`;

export { ActivitiesCard, VideoCard, CompanyBaseCard, CompanyBaseCover, InfluincerCard, MediaCard };
